import { render, staticRenderFns } from "./LastMessages.vue?vue&type=template&id=91893842&scoped=true&"
import script from "./LastMessages.vue?vue&type=script&lang=ts&"
export * from "./LastMessages.vue?vue&type=script&lang=ts&"
import style0 from "./LastMessages.vue?vue&type=style&index=0&id=91893842&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91893842",
  null
  
)

export default component.exports